'use client';

import { useEffect } from 'react';

interface ErrorForwarderProps {
  error: Error | { code: string; message: string; [key: string]: any } | any;
}

/**
 * 서버 컴포넌트에서 받은 에러 객체를 클라이언트 측에서 다시 throw하여
 * ErrorBoundary가 처리하도록 전달하는 공용 컴포넌트입니다.
 */
export default function ServerErrorForwarder({ error }: ErrorForwarderProps): React.ReactNode {
  useEffect(() => {
    if (typeof error === 'object' && error !== null) {
      throw new Error(JSON.stringify(error));
    }
    throw new Error(String(error));
  }, [error]);
  
  return <div />;
}
